import { ethers as utils } from 'ethers';
export const INTERVALS = [10, 100, 1000, 10000, 100000, 1000000];
const RATES = [10, 5, 4, 3, 2, 1];
const ZERO = '0x0000000000000000000000000000000000000000';
export const paymentInterface = new utils.Interface([
'event Transfer(address indexed from, address indexed to, uint256 value)',
...INTERVALS.map((n) => 'event NewReceiver' + n + '(address indexed newReceiver, uint256 indexed transactionCounter)')]
);
export function decodePaymentLogs(logs) {
  return logs.map(log => ({ ...log, logIndex: log.index ?? log.logIndex })).sort((a, b) => a.blockNumber - b.blockNumber || a.logIndex - b.logIndex).map((log) => {
    try {return { ...log, parsed: paymentInterface.parseLog(log) };} catch {return { ...log, parsed: null };}
  });
}
// Match the complete sequential fee distribution, not a generic balance increase.
// The final main Transfer is excluded, even if its recipient is also a winner.
export function collectIntervalPayments(logs, initialReceivers, origins, wallet) {
  const receivers = { ...initialReceivers };
  let total = BigInt(0);
  const ids = [];
  const target = wallet.toLowerCase();
  for (let i = 0; i < logs.length; i++) {
    const log = logs[i];
    const event = log.parsed;
    if (event?.name.startsWith('NewReceiver')) {
      receivers[event.name.slice(11)] = event.args[0].toLowerCase();
      continue;
    }
    if (event?.name !== 'Transfer') continue;
    const origin = origins[log.transactionHash]?.toLowerCase();
    if (!origin || origin === target) continue;
    const payable = INTERVALS.map((n, index) => ({ receiver: receivers[n]?.toLowerCase(), rate: RATES[index] }))
    .filter((x) => x.receiver && x.receiver !== ZERO && x.receiver !== origin);
    if (!payable.some((x) => x.receiver === target)) continue;
    const sequence = logs.slice(i, i + payable.length + 1);
    if (sequence.length !== payable.length + 1 || sequence.some((x) => x.transactionHash !== log.transactionHash || x.parsed?.name !== 'Transfer' || x.parsed.args[0].toLowerCase() !== event.args[0].toLowerCase())) continue;
    let base = sequence.reduce((sum, x) => sum + BigInt(x.parsed.args[2]), BigInt(0));
    let matches = true;
    for (let j = 0; j < payable.length; j++) {
      const fee = base * BigInt(payable[j].rate) / BigInt(100);
      if (sequence[j].parsed.args[1].toLowerCase() !== payable[j].receiver || !(sequence[j].parsed.args[2] === BigInt(fee))) {matches = false;break;}
      base = base - BigInt(fee);
    }
    if (!matches) continue;
    for (let j = 0; j < payable.length; j++) {
      if (payable[j].receiver === target) {
        total = total + BigInt(sequence[j].parsed.args[2]);
        ids.push(sequence[j].transactionHash + ':' + sequence[j].logIndex);
      }
    }
    i += payable.length; // main transfer has also been consumed
  }
  return { receivers, total, ids };
}
